"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateColumn = function (label, key, className) {
    return { label: label, key: key, className: className };
};
//# sourceMappingURL=tableHelpers.js.map